import { BackendEvent } from "media-stream-sdk";
import React, { useEffect, useRef } from "react";
interface MessageComponentProps {
  messages: Array<BackendEvent>;
}

const MessageComponent: React.FC<MessageComponentProps> = ({ messages }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <section className="messages-section">
      <div className="messages-header">
        <h2>Messages</h2>
        <span className="messages-count">{messages.length}</span>
      </div>
      <div id="messages" className="messages-list">
        {messages.map((message) => {
          const time = new Date(message.timestamp * 1000).toLocaleString(
            "it-IT"
          );
          const content = JSON.stringify(message.content)
            .replace(/\\r/g, "\r")
            .replace(/\\n/g, "\n")
            .replaceAll('"', "");
          return (
            <article
              key={`${message.type}-${message.timestamp}`}
              className={`message-card type-${
                message.type.toLowerCase?.() || message.type
              }`}
            >
              <header className="message-meta">
                <span className="message-type">{message.type}</span>
                <time className="message-time">{time}</time>
              </header>
              <pre className="message-content">
                {message.content.text ?? message.content.clientId}
              </pre>
            </article>
          );
        })}
        <div ref={messagesEndRef} />
      </div>
    </section>
  );
};

export default MessageComponent;
